import NamaPlace from "@/utils/presenters/NamaPlace.ts";
import MetaData from "@/utils/common/MetaData.ts";
import PlaceTokens from "@/utils/constants/PlaceTokens";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import Translator from "@/utils/common/Translator.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import {LocationQueryRaw} from "vue-router";
import RouteNames from "@/router/RouteNames.ts";
import ListScreenLayout = namaTypes.ListScreenLayout;

export default class ListPlace extends NamaPlace {
  private _title: string = "";
  private _iconCode: string = "";

  constructor(q?: LocationQueryRaw) {
    super(q);
    if (this.shouldResetEditViewParams()) {
      let query = this.fetchQuery();
      delete query[PlaceTokens.PRM_ID];
      delete query[PlaceTokens.PRM_CODE];
      delete query[PlaceTokens.PRM_TAB_ID];
      delete query[PlaceTokens.PRM_QUICKCREATE_REQUESTER];
      delete query[PlaceTokens.PRM_QUICKCREATE];
      delete query[PlaceTokens.PRM_PAGE_ID];
      delete query[PlaceTokens.PRM_VIEW];
      delete query[PlaceTokens.PRM_FIELDS];
      delete query[PlaceTokens.PRM_FOCUS_ON_FIELD];
      delete query[PlaceTokens.PRM_EDIT_TEMPLATE_ID];
      delete query[PlaceTokens.PRM_VERSION];
    }
  }

  shouldResetEditViewParams(): boolean {
    return true;
  }
  get entityType(): string | undefined {
    return this.query[PlaceTokens.PRM_ENTITY_TYPE];
  }

  set entityType(value: string) {
    this.query[PlaceTokens.PRM_ENTITY_TYPE] = value;
  }

  get currentPage(): number | undefined {
    let currentPage = this.query[PlaceTokens.PRM_PAGE] ?? '';
    return currentPage ? Number.parseInt(currentPage) : 0;
  }

  set currentPage(value: number) {
    this.query[PlaceTokens.PRM_PAGE] = value + '';
  }

  get pageSize(): number | undefined {
    let pageSizeStr = this.query[PlaceTokens.PRM_PAGE_SIZE] ?? '';
    let parsedValue = Number.parseInt(pageSizeStr);
    if (pageSizeStr.toLowerCase() === "all")
      return -1
    else if (isNaN(parsedValue))
      return undefined
    else
      return parsedValue;
  }

  set pageSize(value: number) {
    this.query[PlaceTokens.PRM_PAGE_SIZE] = value + '';
  }

  get orderBy(): string | undefined {
    return this.query[PlaceTokens.PRM_SORT_BY];
  }

  set orderBy(value: string) {
    this.query[PlaceTokens.PRM_SORT_BY] = value;
  }

  get listViewName(): string | undefined {
    return this.query[PlaceTokens.PRM_LIST_VIEW_NAME];
  }

  set listViewName(value: string) {
    if (ObjectChecker.isEmptyOrNull(value))
      return;
    this.query[PlaceTokens.PRM_LIST_VIEW_NAME] = value;
  }

  get criteria(): string | undefined {
    return this.query[PlaceTokens.PRM_CRITERIA];
  }

  set criteria(value: string) {
    this.query[PlaceTokens.PRM_CRITERIA] = value;
  }

  get questions(): string | undefined {
    return this.query[PlaceTokens.PRM_QUESTIONS];
  }

  set questions(value: string) {
    this.query[PlaceTokens.PRM_QUESTIONS] = value;
  }

  get ascending(): boolean | undefined {
    return ObjectChecker.valueOfBoolean(this.query[PlaceTokens.PRM_ASCENDING]) ?? true;
  }

  set ascending(value: boolean) {
    this.query[PlaceTokens.PRM_ASCENDING] = value+'';
  }

  get showTree(): boolean | undefined {
    return ObjectChecker.valueOfBoolean(this.query[PlaceTokens.PRM_SHOW_TREE]) ?? false;
  }

  set showTree(value: boolean) {
    this.query[PlaceTokens.PRM_SHOW_TREE] = value + '';
  }

  get extraCriteria(): string | undefined {
    return this.query[PlaceTokens.PRM_EXTRA_CRITERIA];
  }

  set extraCriteria(value: string) {
    this.query[PlaceTokens.PRM_EXTRA_CRITERIA] = value;
  }

  getDisplayColumns() {
    return MetaData.getCachedDisplayedColumns(this.entityType, this.listViewName);
  }

  get title(): string {
    return this._title;
  }

  set title(value: string) {
    this._title = value;
  }

  get iconCode(): string {
    return this._iconCode;
  }

  set iconCode(value: string) {
    this._iconCode = value;
  }
  get quickFilters(): string | undefined {
    return this.query["qf"];
  }

  set quickFilters(value: string | undefined) {
    if (ObjectChecker.isEmptyOrNull(value))
      delete this.query["qf"];
    else
      this.query["qf"] = value;
  }
  override fetchQuery(): Record<string, string | undefined> {
    let query = super.fetchQuery();
    if (!query[PlaceTokens.PRM_CRITERIA])
      delete query[PlaceTokens.PRM_CRITERIA];
    if (!query["qf"])
      delete query["qf"];
    return query;
  }

  override getTitleForWindow(): string {
    if (!this.entityType)
      return '';
    let layout: ListScreenLayout | undefined = ClientCache.getListLayoutIfFetched(this.entityType, this.listViewName);
    return Translator.getListViewTitle(this.entityType, this.listViewName, layout, ClientCache.getMenuLineBySrc(this.src));
  }

  override getRouteName(): string | null {
    return RouteNames.LIST_VIEW_ROUTE;
  }
}
